export default "__VITE_ASSET__zCQpwonT__"